import { FC, useCallback } from 'react';
import { AdvancedFilterRow, SingleSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback, useSelectorWithConfig } from 'shared/hooks';
import { selectWithNeighborsFilter } from 'shared/selectors/advancedFilters';

export const WithNeighborsContainer: FC = () => {
  const { label, value, options, isOffByDefault, visible } = useSelectorWithConfig(selectWithNeighborsFilter);

  const onChange = useFilterChangeCallback();

  const handleWithNeighborsChange = useCallback(
    (newValue: boolean) => {
      const action = 'setWithNeighbors' as const;

      if (isOffByDefault) {
        onChange({ action, arguments: [newValue ? true : null] });
      } else {
        onChange({ action, arguments: [newValue ? null : false] });
      }
    },
    [isOffByDefault, onChange],
  );

  if (!visible) {
    return null;
  }

  return (
    <AdvancedFilterRow label={label}>
      <SingleSelectionAdvancedFilter value={value} options={options} onFilterChange={handleWithNeighborsChange} />
    </AdvancedFilterRow>
  );
};
